<template>
  <div class="container-fluid">
    <PainelAcesso>
      <template #corpo>
        <div v-if="flagsDeControle.carregandoDados.status" class="d-flex w-75 mx-auto">
          <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
          <b-spinner class="ml-2" variant="danger"></b-spinner>
        </div>
        <form class="mt-2" v-show="apresentarOfertaBoasVindasPendente && possuiOferta">
          <div class="d-flex flex-column justify-content-center mx-auto my-2 position-relative">
            <!-- Imagem para desktop -->
            <b-img :src="imagemTelaOferta()" class="img-fluid d-none d-md-block" alt="Imagem da oferta"></b-img>
            <!-- Imagem para mobile -->
            <b-img :src="imagemTelaOfertaMobile()" class="img-fluid d-block d-md-none" alt="Imagem da oferta para mobile"></b-img>
            <div class="position-absolute w-100 d-flex justify-content-center" style="bottom: 10px;">
              <b-button class="btn-sm btn-md btn-lg col-auto m-1" variant="outline-secondary" :disabled="flagsDeControle.manipulandoDados.status" @click="negarOferta()">Não, Obrigado</b-button>
              <b-button class="btn-sm btn-md btn-lg col-auto m-1" variant="verde" :disabled="flagsDeControle.manipulandoDados.status" @click="ativarOferta()">Comprar</b-button>
            </div>
          </div>
          <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex justify-content-center align-items-center">
            <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
        </form>
        <PagamentoOferta v-show="apresentarPagamentoPendente" :oferta="oferta" :flags="flags" @enviarNotificacao="repassarNotificacao" @finalizandoPagamento="emitirEventoFinalizacao"/>
      </template>
    </PainelAcesso>
  </div>
</template>

<script>
import OfertaBoasVindas from './js/ofertaBoasVindas'
export default OfertaBoasVindas
</script>

<style scoped>
@import "./scss/ofertaBoasVindas.scss";
</style>
